import React from "react";
import { FieldProps } from "@rjsf/utils";
import { get } from "lodash";
import MultiSelect from "../../Inputs/MultiSelect";
import { Input } from "../__styles__/Inputs";

export const MultiSelectInput = (props: FieldProps) => {
  const value = props.formData ?? null;

  const oneOfOptions = get(props.schema, "items.oneOf");
  const options =
    oneOfOptions
      ?.map((option: any) => {
        if (typeof option === "object" && option.const && option.title) {
          return { value: option.const, label: option.title };
        }
        return null;
      })
      .filter(Boolean) || [];

  return (
    <Input
      id={props.idSchema.$id}
      isSubmissionBuilder={props.isSubmissionBuilder}
    >
      <MultiSelect
        value={value}
        onChange={props.onChange}
        options={options}
        name={props.name}
        required={props.required && !props.disabled}
        label={props.schema.title}
        error={props.rawErrors?.join(", ")}
        disabled={props.disabled}
        tooltip={props.uiSchema?.["ui:tooltipText"]}
        helperText={props.uiSchema?.["ui:helperText"]}
        placeholder={props.uiSchema?.["ui:placeholder"]}
      />
    </Input>
  );
};
